export const appWidth = 1024;
